import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  @Input() alt: string = ''; // Alt text
  @Input() class: string = ''; // Additional classes
  public projectName = environment.projectName
  public src: string;
  @Input() customClass: string = '';
  constructor() { }

  ngOnInit() {
    if(this.projectName === 'R2S'){
      if(this.customClass === 'small-logo'){
        this.src= "assets/img/logo_small.png"
      }else{
        this.src= "assets/img/r2s.png"
      }
    }else if(this.projectName === 'BAC'){
      if(this.customClass === 'shrinked-bac-logo'){
        this.src = "assets/img/bac.png"
      }else{
        this.src = "assets/img/Logo_OG_BicialCole.png"
        this.class+= this.customClass
      }
       
    }
  }

}
